__turbopack_context__.v({
  "clearButton": "FilterSearch-module-scss-module__V-AePa__clearButton",
  "container": "FilterSearch-module-scss-module__V-AePa__container",
  "input": "FilterSearch-module-scss-module__V-AePa__input",
  "inputContainer": "FilterSearch-module-scss-module__V-AePa__inputContainer",
  "inputLabel": "FilterSearch-module-scss-module__V-AePa__inputLabel",
  "inputPrefix": "FilterSearch-module-scss-module__V-AePa__inputPrefix",
  "inputWrapper": "FilterSearch-module-scss-module__V-AePa__inputWrapper",
});
